module.exports = __webpack_public_path__ + "img/cursor-move-target-right.45ff01e1.svg";